<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} ứng dụng</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} ứng dụng</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} ứng dụng</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Mã ứng dụng" prop="code">
                <el-input
                  type="text"
                  v-model="mData.dataForm.code"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item label="Tên ứng dụng" prop="name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Bundle/Application ID" prop="application_id">
                <el-input
                  type="text"
                  v-model="mData.dataForm.application_id"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="2">
              <el-form-item label=" " prop="Trạng thái">
                <el-checkbox
                  v-model="mData.dataForm.status"
                  :disabled="mData.viewMode == 'detail'"
                >Hoạt động</el-checkbox>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import AppModel from "./AppModel";
import AppApi from "../../../moduleApi/AppApi";

export default {
  components: {
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "App",
        dataDefault: {
        },
        dataForm: MethodService.copyObject(AppModel.dataForm),
        validForm: AppModel.validForm,
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if(data.status == null)
          {
            data.status = false;
          }
          if (type == "create") {
            await AppApi.create(data);
            this.fn_resetForm();
          }
          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            await AppApi.update(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(AppModel.dataForm);
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await AppApi.findById(id);
      this.mData.dataForm = res.result;
    },
    async fn_initDataDefault() {
    },
  },
  created: function() {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
<style scoped>
</style>